import React from 'react'
import { Image } from '@chakra-ui/react'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'
import PayPayLogoImage from '@images/external_payment/paypay_logo.webp'

export const PayPayOption = () => <Image w="85px" h="23px" src={buildAssetUrlString(PayPayLogoImage)} alt="PayPay" objectFit="contain" />
